import React from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch } from 'react-redux'

import findIndex from 'lodash/findIndex'

import { Swiper, SwiperSlide } from 'swiper/react'
import SwiperCore, { Navigation } from 'swiper'
import 'swiper/swiper.scss'
import 'swiper/components/navigation/navigation.scss'
import { PhotoType } from '../../store/commonTypes'
import { useHistory, useLocation } from 'react-router-dom'

import { createLocalizedPath } from '../../utils/localizationHelpers'
import { setPageToReturnFromPayment } from '../../store/common/commonSlice'

import paths from '../../paths'

interface Props {
    list: PhotoType[]
    photo: PhotoType
}

SwiperCore.use([Navigation])

const SwiperMembershipRequied: React.FunctionComponent<Props> = ({ list, photo }: Props) => {
    const [t] = useTranslation()
    const history = useHistory()
    const dispatch = useDispatch()
    const location = useLocation()
    return (
        <Swiper navigation initialSlide={findIndex(list, photo)} className="mySwiper">
            {list.map((item) => (
                <SwiperSlide key={item.id}>
                    <img className="photo_blur" src={item.thumbnail_url} alt="" />
                    <div className="content-no-xxl-member">
                        {/*<p>{t('You must be a member')}</p>*/}
                        {/*<p>{t('to open this photo')}</p>*/}
                        <p>{t('Become a member to view this photo')}</p>
                        <button
                            className="login-button"
                            onClick={() => {
                                history.push(createLocalizedPath(paths.payment.path))
                                dispatch(setPageToReturnFromPayment(location.pathname))
                            }}
                        >
                            {t('Become an XXL member')}
                        </button>
                    </div>
                </SwiperSlide>
            ))}
        </Swiper>
    )
}

export default SwiperMembershipRequied
